
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import { getArticleListByTypes } from '@/api/apis';
import { baseUrl } from '@/utils/constants';

export default defineComponent({
  name: 'ContactUs',
  created() {
    this.loadData();
  },
  data() {
    return {
      baseUrl,
      contactus: null,
      loaded: false
    };
  },
  computed: {
    ...mapState(['lang'])
  },
  watch: {
    lang() {
      this.loadData();
    }
  },
  methods: {
    async loadData() {
      const res = await getArticleListByTypes({
        types: 5
      });

      if (res.success) {
        const data = res.result || [];

        this.contactus = data[0] || null;
      }

      this.loaded = true;
    }
  }
});
